import React, { useEffect, useState } from "react";
import { Box, CircularProgress, CssBaseline, Typography, Grid } 
from "@mui/material";
import Dashboard from "../components/shared/dashboard/dashboard";
import MetaDecorator from "../services/meta_decorator";
import Newheader from "../components/shared/newheader";
import Footer from "../components/shared/footer";
import AccessLocalStorage from "../services/localStorage";
import InactivityMeter from "../components/shared/inactivitymeter";
import { getApiUrl } from "../services/api_service";
import { ConvertText } from "../services/utility";
import { SeizureReportByType } from "../components/epilepsydashboard/seizurereportbytype";
import { SeizureReportDateRange, SeizureReportDateRangeDisplay } from "../components/epilepsydashboard/enums";
import { SeizureReportMonthly } from "../components/epilepsydashboard/seizurereportmonthly";
import { SeizureReportQOL } from "../components/epilepsydashboard/seizurereportqol";
import { dashboardText, epilepsyHeading2, footerContainer, mainGrid, paddingboxeven, pcolor, primaryColor, select, selectUnderLined, whitecolor } from "../style2";
import BackToTop from "../components/shared/scrollTop";
import { AISummaryList } from "../components/shared/aisummarylist";

const Epilepsy_Dashboard = () => {
  const [dateRange, setDateRange] = useState(SeizureReportDateRange.Last90Days); // Default to Last 90 Days
  const [taster, setTaster] = useState(null);
  const [loadingTaster, setLoadingTaster] = useState(false);
  const [errorTaster, setErrorTaster] = useState('');
  //const classes = useStyles();
  const ls = new AccessLocalStorage();

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) { return; }

    setLoadingTaster(true);
    setErrorTaster('');

    let error = 'Unable to load epilepsy information.';
    fetch(
      `${getApiUrl()}/seizurediary/taster/${ls.getCurrentPatientId()}?range=${dateRange}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          response.json().then(data => {
            setTaster(data);
          }).catch((err) => {
            setErrorTaster(error);
            console.log(err);
          });
        } else {
          setErrorTaster(error);
        }
      })
      .catch((err) => {
        setErrorTaster(error);
        console.log(err);
      })
      .finally(() => { setLoadingTaster(false); });
  }, [dateRange]);

  return (
    <Box sx={{ bgcolor: "#f2eee4", minWidth:"1200px" }}>
      <CssBaseline />
      <MetaDecorator title={"EnrichMyCare - Patient Profile"} description={"Professional dashboard app"} />
      <Newheader tab_disabled={true} show_profile_button={true} show_back_button={true} fullWidth={true} />

      <Box component="div"  sx={{...dashboardText, textAlign: "center", fontWeight: "bold", marginTop: "2rem", marginBottom: "2rem" }}>
          Epilepsy Dashboard
      </Box>

      <Dashboard fullWidth={true} profile_image={true} detail_text={true} share_icons={false} end_card={true} cards={true} health_profile_button={true} />
      <Box m={1} />
      <AISummaryList pathwayId={2} fullWidth={true} />
      <Box sx={paddingboxeven} >
        <Grid container>
          <Grid item xs={12}>
            {loadingTaster ? <Box display="flex" justifyContent="center" alignItems="center" height="150px" sx={mainGrid}>
              <CircularProgress />
            </Box> : null}
            {errorTaster !== '' ? <Box display="flex" justifyContent="center" alignItems="center" height="150px" sx={mainGrid}>
              <Typography style={{ color: "red" }}>{errorTaster}</Typography>
            </Box> : null}
            {!loadingTaster && taster != null ?
              <Box sx={mainGrid}>
                
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                  <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                    <Typography component="div" sx={{...epilepsyHeading2, ...primaryColor}} >{taster.dateRangeDisplay}</Typography>
                  </Box>
                  <Box sx={{ minWidth: 220, display: 'flex', justifyContent: 'flex-end' }}>
                    <select disabled={loadingTaster}  style={{...selectUnderLined, marginBottom:"10px"}} 
                      value={dateRange} onChange={(event) => {
                        setDateRange(event.target.value);
                      }}>
                      <option value={SeizureReportDateRange.Today}>
                        {SeizureReportDateRangeDisplay[SeizureReportDateRange.Today]}
                      </option>
                      <option value={SeizureReportDateRange.Yesterday}>
                        {SeizureReportDateRangeDisplay[SeizureReportDateRange.Yesterday]}
                      </option>
                      <option value={SeizureReportDateRange.ThisWeek}>
                        {SeizureReportDateRangeDisplay[SeizureReportDateRange.ThisWeek]}
                      </option>
                      <option value={SeizureReportDateRange.Last7Days}>
                        {SeizureReportDateRangeDisplay[SeizureReportDateRange.Last7Days]}
                      </option>
                      <option value={SeizureReportDateRange.Last30Days}>
                        {SeizureReportDateRangeDisplay[SeizureReportDateRange.Last30Days]}
                      </option>
                      <option value={SeizureReportDateRange.ThisMonth}>
                        {SeizureReportDateRangeDisplay[SeizureReportDateRange.ThisMonth]}
                      </option>
                      <option value={SeizureReportDateRange.Last90Days}>
                        {SeizureReportDateRangeDisplay[SeizureReportDateRange.Last90Days]}
                      </option>
                      <option value={SeizureReportDateRange.Last6Months}>
                        {SeizureReportDateRangeDisplay[SeizureReportDateRange.Last6Months]}
                      </option>
                      <option value={SeizureReportDateRange.ThisYear}>
                        {SeizureReportDateRangeDisplay[SeizureReportDateRange.ThisYear]}
                      </option>
                    </select>
                  </Box>
                </Box>
                <Grid container >
                  <Grid item md={6} lg={3} xs={12} style={{ padding: 3 }}>
                    <Box bgcolor="#fff" p={3} sx={{ borderRadius: "5px", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                      <Typography fontWeight="bold" component="div" sx={{...epilepsyHeading2, ...primaryColor}}>
                        Total Seizures
                      </Typography>
                      <Typography fontWeight="bold" variant="h1" component="div"
                        sx={{ ...primaryColor,
                          textAlign: "center", flexGrow: 1, padding: "10px", display: "flex",
                          alignItems: "center", justifyContent: "center"
                        }}>
                        {ConvertText(taster.totalSeizures, 0, "-")}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item md={6} lg={3} xs={12} style={{ padding: 3 }}>
                    <Box bgcolor="#fff" p={3} sx={{ borderRadius: "5px" }}>
                      <Typography fontWeight="bold" component="div" sx={{...epilepsyHeading2, ...primaryColor}}>
                        Length of Seizure
                      </Typography>
                      <Box m={1}></Box>
                      <Box p={1} sx={{ display: "flex", backgroundColor: "rgb(0, 100, 0)", fontSize: "17px", color: whitecolor, justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                        <span style={{ flexGrow: 1 }}>&lt; 1 min</span>
                        <span style={{ padding: "0px 5px" }}>{ConvertText(taster.totalLOSOneMin, 0, "-")}</span>
                      </Box>
                      <Box m={1}></Box>
                      <Box p={1} sx={{ display: "flex", backgroundColor: "rgb(124, 179, 66)", fontSize: "17px", color: whitecolor, justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                        <span style={{ flexGrow: 1 }}> 1-5 min</span>
                        <span style={{ padding: "0px 5px" }}>{ConvertText(taster.totalLOSOneToFiveMin, 0, "-")}</span>
                      </Box>
                      <Box m={1}></Box>
                      <Box p={1} sx={{ display: "flex", backgroundColor: "rgb(245, 124, 0)", fontSize: "17px", color: whitecolor, justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                        <span style={{ flexGrow: 1 }}> 5-10 min</span>
                        <span style={{ padding: "0px 5px" }}>{ConvertText(taster.totalLOSFiveToTenMin, 0, "-")}</span>
                      </Box>
                      <Box m={1}></Box>
                      <Box p={1} sx={{ display: "flex", backgroundColor: "rgb(211, 47, 47)", fontSize: "17px", color: whitecolor, justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                        <span style={{ flexGrow: 1 }}> &ge; 10 min</span>
                        <span style={{ padding: "0px 5px" }}>{ConvertText(taster.totalLOSMoreThanTenMin, 0, "-")}</span>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item md={6} lg={3} xs={12} style={{ padding: 3 }}>
                    <Box bgcolor={whitecolor} p={3} sx={{ borderRadius: "5px", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                      <Typography fontWeight="bold" component="div" sx={{...epilepsyHeading2, ...primaryColor}}>
                        Rescue Medication
                      </Typography>
                      <Typography fontWeight="bold" variant="h1" component="div"
                        sx={{...primaryColor,
                          textAlign: "center", flexGrow: 1, padding: "10px", display: "flex",
                          alignItems: "center", justifyContent: "center"
                        }}
                        >
                        <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
                          <Typography component="span" fontWeight="bold" sx={{ fontSize: "5rem" }}>{ConvertText(taster.totalRescueMedications, 0, "-")}</Typography>
                          {taster.totalRescueMedications > 0 ? <Typography component="span" sx={{ fontSize: "14px", paddingLeft: "5px" }}>times</Typography> : null}
                        </Box>
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item md={6} lg={3} xs={12} style={{ padding: 3 }}>
                    <Box bgcolor={whitecolor} p={3} sx={{ borderRadius: "5px" }}>
                      <Typography fontWeight="bold" component="div" sx={{...epilepsyHeading2, ...primaryColor}}>
                        Recovery <Typography component="span" sx={{ fontSize: "14px", paddingLeft: "5px" }}>(times)</Typography>
                      </Typography>
                      <Box m={1}></Box>
                      <Box p={1} sx={{ display: "flex", fontSize: "17px", backgroundColor:"rgba(211, 211, 211, 0.5)", color: pcolor, justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                        <span style={{ flexGrow: 1, fontWeight:"bold" }}>&lt; 1 min</span>
                        <span style={{ padding: "0px 5px" }}>{ConvertText(taster.recovery.LessThan1Minute, 0, "-")}</span>
                      </Box>
                      <Box m={1}></Box>
                      <Box p={1} sx={{ display: "flex", color: pcolor, fontSize: "17px", backgroundColor:"rgba(211, 211, 211, 0.5)", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                        <span style={{ flexGrow: 1, fontWeight:"bold" }}> &lt; 10 mins</span>
                        <span style={{ padding: "0px 5px" }}>{ConvertText(taster.recovery.LessThan10Minutes, 0, "-")}</span>
                      </Box>
                      <Box m={1}></Box>
                      <Box p={1} sx={{ display: "flex", fontSize: "17px", color: pcolor, backgroundColor:"rgba(211, 211, 211, 0.5)", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                        <span style={{ flexGrow: 1, fontWeight:"bold" }}> &gt; 10 mins</span>
                        <span style={{ padding: "0px 5px" }}>{ConvertText(taster.recovery.MoreThan10Minutes, 0, "-")}</span>
                      </Box>
                      <Box m={1}></Box>
                      <Box p={1} sx={{ display: "flex", fontSize: "17px", color: pcolor, backgroundColor:"rgba(211, 211, 211, 0.5)", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px" }}>
                        <span style={{ flexGrow: 1, fontWeight:"bold" }}> Slept</span>
                        <span style={{ padding: "0px 5px" }}>{ConvertText(taster.recovery.Slept, 0, "-")}</span>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box> : null}
          </Grid>
          <Grid item xs={12}>
            <SeizureReportByType />
          </Grid>
          <Grid item xs={12}>
            <SeizureReportMonthly />
          </Grid>
          <Grid item xs={12}>
            <SeizureReportQOL />
          </Grid>
          
        </Grid>
      </Box>
      <BackToTop />
      <InactivityMeter />
      <Box sx={{...footerContainer, position: "static", marginTop: "20px" }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default Epilepsy_Dashboard;